var _style, _g, _g2, _path, _path2, _path3, _path4, _path5, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEducationIcon9(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 162.7 162.7",
    style: {
      enableBackground: "new 0 0 162.7 162.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:#F9D8D9;stroke:#3B3C3C;stroke-width:5.6693;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st2{fill:#FBE6E7;stroke:#3B3C3C;stroke-width:5.6693;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st3{fill:#FBE6E7;stroke:#3B3C3C;stroke-width:2.8346;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st4{fill:#54494B;stroke:#3B3C3C;stroke-width:5.6693;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st5{fill:none;stroke:#3B3C3C;stroke-width:2.8346;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st6{fill:#68C4DA;}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible",
      opacity: 0.15
    },
    width: 169,
    height: 170,
    xlinkHref: "DB2843F263A83455.png",
    transform: "matrix(1 0 0 1 -3.5039 -0.8039)"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 81.3,
    cy: 81.3,
    r: 75.6
  })))), /*#__PURE__*/React.createElement("g", null, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "st1",
    cx: 123.9,
    cy: 95.4,
    rx: 11.9,
    ry: 13.9
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st2",
    cx: 38.8,
    cy: 95.9,
    rx: 11.9,
    ry: 13.9
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M122.7,89L122.7,89l0-17.5c0-20.1-18.5-36.4-41.3-36.4S40.1,51.5,40.1,71.6V89h0c0,2.9,0.4,5.7,1.2,8.4h80.3 C122.2,94.7,122.6,91.9,122.7,89z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M81.3,23.5c-25.8,0-46.8,17.8-46.8,39.9v34v22.2c0,4.9,4,8.9,8.9,8.9l17.4,6.9c13.2,5.2,27.9,5.1,41-0.2 l16.3-6.7c4.9,0,8.9-4,8.9-8.9V97.4V86.8l0.2-15.3c0.6-2.6,1-5.3,1-8.1C128.1,41.4,107.2,23.5,81.3,23.5z M43.5,86.8l0.2-17.1 c0.7,1.1,3.6,4.9,10.1,4.2c7.5-0.8,15.1-8.9,15.1-8.9s1.8,4.6,6.8,4.6c4.9,0,6.5-4.6,6.5-4.6s0.5,4.3,5.5,4.3 c5.1,0,7.8-4.3,7.8-4.3S102,74,109.6,74c3.8,0,6.6-1.5,8.5-3v26.4H43.5V86.8z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M76.4,107.7c0,0,0.1,3.3,5,3.3c4.9,0,4.8-3.3,4.8-3.3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M58.7,81.6c1.4-3,4.9-5.2,9-5.2c3.3,0,6.2,1.4,7.9,3.6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M104.1,81.6c-1.4-3-4.9-5.2-9-5.2c-3.3,0-6.2,1.4-7.9,3.6"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible"
    },
    width: 51,
    height: 25,
    xlinkHref: "DB2843F263A83457.png",
    transform: "matrix(1 0 0 1 55.4961 76.1961)"
  }), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 68.9,
    cy: 88.8,
    r: 3.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 93.8,
    cy: 88.8,
    r: 3.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 93.8,
    cy: 88.8,
    r: 1.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 68.9,
    cy: 88.8,
    r: 1.7
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEducationIcon9);
export default __webpack_public_path__ + "static/media/Education-Icon_9.6fd61875e15429d915b6cfa16433263d.svg";
export { ForwardRef as ReactComponent };